export default class ToggleAccordion {
    /**
     * Create ToggleAccordion instance.
     * @param {(String|HTMLElement)} element - element to initialize plugin
     */
    constructor(element = 'js-accordion-toggle') {
        this.element = element;
        this.parentEl = null;
        this.contentEl = null;
        this.classList = {
            activeClass: 'is-active',
            contentClass: 'js-accordion-content'
        }

        this.create();
    }

    /**
     * Create before initializing plugin
     */
    create() {
        if (typeof this.element === 'string') {
            const elements = [...document.querySelectorAll(`.${this.element}`)];

            if (elements) {
                elements.forEach(el => new ToggleAccordion(el));
            }
        } else {
            this.init();
        }
    }

    /**
     * Init plugin
     */
    init() {
        const { contentClass } = this.classList;

        this.parentEl = this.element.parentElement;
        this.contentEl = this.parentEl.querySelector(`.${contentClass}`);
        this.element.addEventListener('click', this.toggleAccordion.bind(this));
    }

    /**
     * Toggle accordion depends on current state
     */
    toggleAccordion(e) {
        e.preventDefault();

        const { activeClass } = this.classList;
        const isAccordionOpened = this.parentEl.classList.contains(activeClass);

        isAccordionOpened ? this.close() : this.open();
    }

    /**
     * Open accordion
     */
    open() {
        const { activeClass } = this.classList;

        this.parentEl.classList.add(activeClass);
        this.contentEl.style.height = `${this.contentEl.scrollHeight}px`;
    }

    /**
     * Close accordion
     */
    close() {
        const { activeClass } = this.classList;

        this.parentEl.classList.remove(activeClass);
        this.contentEl.style.height = '';
    }
}
